import * as React from 'react';
import { motion } from 'framer-motion';

import { Chip, Grid } from '@mui/material';
import { FileDownloadOutlined } from '@mui/icons-material';

import './DownloadPaperStyles.css';

export interface IDownloadItemProps {
    label: string;
    url: string;
}

const DownloadItem = (props: IDownloadItemProps) => {
    const { label, url } = props;

    const handleDownload = () => {
        let element = document.createElement('a');

        element.setAttribute('href', url);
        element.setAttribute('download', getFileNameFromUrl(url));
        
        document.body.appendChild(element);
        element.click();
        document.body.removeChild(element);
    }

    const getFileNameFromUrl: (arg0: string) => string = (fileUrl) => {
        const urlComponents = fileUrl.split('/');

        // extract file from url
        let filename = urlComponents[urlComponents.length - 1];

        // remove file extension from name
        filename = filename.split('.')[0];

        return filename;
    }

    return (
        <motion.div className="download-item-chip-div" whileHover={{ scale: 1.03 }}>
            <Grid className="download-item-container" container direction="row" columns={3}>
                <Grid className="" item xs={2}>
                    <p>{label}</p>
                </Grid>
                <Grid className="" item xs={1}>
                    <Chip icon={<FileDownloadOutlined />} label="Download" color="error" clickable onClick={handleDownload} />
                </Grid>
            </Grid>
        </motion.div>
    );
}

export default DownloadItem;